import React from 'react';

import Card from "@mui/joy/Card";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

import Chip from "@mui/joy/Chip";
import CardContent from "@mui/joy/CardContent";
import {Stack} from "@mui/joy";

// components
import UserSubscriberContext from "../../context/UserSubscriberContext";
import ProfileHorizontalByProps from "../Profile/ProfileHorizontalByProps";
import SliceDetailModal from "./SliceDetailModal";
import OpportunityCard from "../Cards/OpportunityCard";
import {getWeekRange} from "../../utils/misc";

// icons
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import BuildIcon from '@mui/icons-material/Build';
import ForumIcon from '@mui/icons-material/Forum';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';


dayjs.extend(customParseFormat)


class SliceVerticalCard extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            slice: this.props.slice,
        };
    }

    setSlice(slice){
        this.setState({
            slice: slice,
        })
    }

    render() {
        let { start, end } = getWeekRange(this.state.slice.week, this.state.slice.year);
        start.setDate(start.getDate())
        end.setDate(end.getDate() + 1)
        let planDelay = dayjs(this.state.slice.pre_week_completed_on, 'DD.MM.YYYY HH:mm:ss').toDate() - start;
        let endDelay = dayjs(this.state.slice.post_week_completed_on, 'DD.MM.YYYY HH:mm:ss').toDate() - end;
        planDelay = Math.floor(planDelay / (1000 * 60 * 60 * 24));
        endDelay = Math.floor(endDelay / (1000 * 60 * 60 * 24));
        return (
            <Card
                size={'sm'}
                variant={'soft'}
            >
                <CardContent
                    sx={{
                        position: 'relative',
                    }}
                >
                    <SliceDetailModal
                        overlay={true}
                        flat={true}
                        slice={this.state.slice}
                        showOpportunity={this.props.showOpportunity}
                        callBack={this.setSlice.bind(this)}
                    />
                    <Stack
                        spacing={1}
                    >
                        {
                            this.props.showOpportunity?
                                <OpportunityCard
                                    opportunity={this.state.slice.opportunity}
                                    nano={true}
                                />:
                                null
                        }
                        {
                            this.props.showTime ?
                                <Stack
                                    direction={'row'}
                                    alignItems="center"
                                    spacing={1}
                                    flexWrap={'nowrap'}
                                >
                                    <Chip
                                        color={'neutral'}
                                        variant={'plain'}
                                    >
                                        {this.state.slice.year}
                                    </Chip>
                                    <Chip
                                        color={'neutral'}
                                        variant={'plain'}
                                    >
                                        {this.state.slice.week}
                                    </Chip>
                                 </Stack>:
                                null
                        }
                        <Stack
                            direction={'row'}
                            alignItems="center"
                            spacing={1}
                            flexWrap={'nowrap'}
                        >
                            {
                                this.state.slice.role === 'R'?
                                    <Chip
                                        color={this.state.slice.pre_week_completed?planDelay>0?'warning':'success':'danger'}
                                        size={'sm'}
                                    >
                                        План {planDelay>0?'+':''}{planDelay?planDelay:null}
                                    </Chip>:
                                    null
                            }
                            <Chip
                                color={this.state.slice.post_week_completed?endDelay>0?'warning':'success':'danger'}
                                size={'sm'}
                            >
                                Оценка {endDelay>0?'+':''}{endDelay?endDelay:null}
                            </Chip>
                        </Stack>
                        <Stack
                            direction={'row'}
                            alignItems="center"
                            spacing={1}
                            flexWrap={'nowrap'}
                            sx={{
                                width: '100%'
                            }}
                        >
                            <Chip
                                color={this.state.slice.color}
                                // variant={'plain'}
                                size={'sm'}
                            >
                                {this.state.slice.role_human}
                            </Chip>
                        </Stack>
                        {
                            this.state.slice.role === 'R'?
                                <Stack
                                    direction={'row'}
                                    alignItems="center"
                                    spacing={1}
                                    flexWrap={'nowrap'}
                                >
                                    <Chip
                                        variant={'plain'}
                                        startDecorator={<AccessTimeIcon />}
                                        size={'sm'}
                                        sx={{
                                            pr: 0.2
                                        }}
                                    ></Chip>
                                    <Chip
                                        variant={
                                            this.state.slice.duration_fact / this.state.slice.duration_plan > 2?
                                                'solid':
                                                'plain'
                                        }
                                        size={'sm'}
                                        color={
                                            this.state.slice.duration_fact / this.state.slice.duration_plan > 2?
                                                'warning':
                                                'default'
                                        }
                                    >
                                        {this.state.slice.duration_plan}
                                        &nbsp;→&nbsp;
                                        {this.state.slice.duration_fact}
                                    </Chip>
                                </Stack>:
                                null
                        }
                        {
                            this.state.slice.role === 'A'?
                                <Stack
                                    direction={'row'}
                                    alignItems="center"
                                    spacing={1}
                                    flexWrap={'nowrap'}
                                >
                                    <Chip
                                        variant={'plain'}
                                        startDecorator={<CalendarMonthIcon />}
                                        size={'sm'}
                                        sx={{
                                            pr: 0.2
                                        }}
                                    ></Chip>
                                    <Chip
                                        variant={
                                            this.state.slice.post_week_end_date?
                                                'plain':
                                                'solid'
                                        }
                                        size={'sm'}
                                        color={
                                            this.state.slice.post_week_end_date?
                                                'default':
                                                'danger'
                                        }
                                    >
                                        {
                                            this.state.slice.post_week_end_date?
                                                dayjs(this.state.slice.post_week_end_date).format('DD.MM.YYYY'):
                                                <>Не указано</>
                                        }
                                    </Chip>
                                </Stack>:
                                null
                        }
                        <Stack
                            direction={'row'}
                            alignItems="center"
                            spacing={1}
                            flexWrap={'nowrap'}
                        >
                            <Chip
                                variant={'plain'}
                                startDecorator={<BuildIcon />}
                                size={'sm'}
                                sx={{
                                    pr: 0.2
                                }}
                            ></Chip>
                            <Chip
                                variant={
                                    this.state.slice.post_week_progress_score < 5 ?
                                        'solid' :
                                        'plain'
                                }
                                size={'sm'}
                                color={
                                   this.state.slice.post_week_progress_score < 5?
                                        'warning':
                                        'default'
                                }
                            >
                                {this.state.slice.post_week_progress_score}
                            </Chip>
                        </Stack>
                        <Stack
                            direction={'row'}
                            alignItems="center"
                            spacing={1}
                            flexWrap={'nowrap'}
                        >
                            <Chip
                                variant={'plain'}
                                size={'sm'}
                                startDecorator={<ForumIcon />}
                                sx={{
                                    pr: 0.2
                                }}
                            ></Chip>
                            <Chip
                                variant={
                                    this.state.slice.post_week_communication_score < 5?
                                        'solid':
                                        'plain'
                                }
                                size={'sm'}
                                color={
                                    this.state.slice.post_week_communication_score < 5?
                                        'warning':
                                        'default'
                                }
                            >

                                {this.state.slice.post_week_communication_score}
                            </Chip>
                        </Stack>
                        <Stack
                            direction={'row'}
                            alignItems="center"
                            spacing={1}
                            flexWrap={'nowrap'}
                        >
                            {
                                this.props.showOpportunity?
                                    <ProfileHorizontalByProps
                                        user={this.state.slice.operator.user}
                                    />:
                                    null
                            }

                        </Stack>
                    </Stack>
                </CardContent>
            </Card>
        )
    }
}

export default SliceVerticalCard